import React from 'react'
import PropTypes from 'prop-types'
import { Rows, Columns, Icon } from 'src/components'
import { InfoCircleIcon } from 'src/components/icons'
import { getColor } from 'src/styles'
import styles from './Info.scss'

const Info = ({ label, icon, color, children }) => {
  color = getColor(color)
  return (
    <Columns align="center" gap="1rem">
      <span />
      <Rows align="center">
        <Icon className={styles.icon} icon={icon} color={color} />
        <span className={styles.label} style={{ color: color }}>
          {label}
        </span>
      </Rows>
      {children && (
        <Rows className={styles.text} layout="auto" justify="center" style={{ borderColor: color }}>
          {children}
        </Rows>
      )}
    </Columns>
  )
}

Info.defaultProps = {
  icon: InfoCircleIcon,
  color: 'light',
}

Info.propTypes = {
  /**
   * The name of the icon to display.
   */
  icon: PropTypes.elementType,
  /**
   * The info color.
   */
  color: PropTypes.string,
  /**
   * The children displayed next to the icon.
   */
  children: PropTypes.node,
  /**
   * The label under the icon.
   */
  label: PropTypes.node,
}

export default Info
